import React from "react";

import { DVIR } from "~/DVIR";
import { Order } from "~/Order";
import { Time } from "~/Time";

export function DateCreated({ dvir }: { readonly dvir: DVIR }) {
  return (
    <>
      {Time.DateTime.toDateOnly(dvir.lifecycle.created)}{" "}
      {Time.DateTime.toHMM(dvir.lifecycle.created)}
    </>
  );
}

export namespace DateCreated {
  export const column = () => ({
    title: "Date Created",
    dataIndex: "createdDateTime",
    render: (_: unknown, dvir: DVIR) => <DateCreated dvir={dvir} />,
    sorter: (a: DVIR, b: DVIR): Order.Ordering =>
      Time.DateTime.compare(a.lifecycle.created, b.lifecycle.created),
  });
}
